import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Button } from "@gemini/ui";
import { ThreeDimensionalFilledIcon, TwoDimensionalIcon } from "@gemini/icons";
import { useMap } from "react-map-gl/mapbox";
import { THREE_D_PITCH, THREE_D_ZOOM, DEFAULT_PITCH, MAP_STYLES, } from "../../../constants";
import { useMapContext } from "../../../contexts/MapContext";
export const MapThreeDimensional = () => {
    const { current: map } = useMap();
    const { viewport, style, is3DMode, setIs3DMode, setStyle } = useMapContext();
    const handlePress = () => {
        if (!map)
            return;
        if (is3DMode) {
            setStyle(MAP_STYLES.STANDARD);
        }
        else {
            setStyle(MAP_STYLES.THREE_DIMENSIONAL);
        }
        setIs3DMode(!is3DMode);
    };
    useEffect(() => {
        if (!map)
            return;
        if (is3DMode) {
            map.easeTo({
                pitch: THREE_D_PITCH,
                zoom: THREE_D_ZOOM,
                duration: 2000,
                center: viewport.center,
            });
        }
        else {
            map.easeTo({
                pitch: DEFAULT_PITCH,
                duration: 2000,
                center: viewport.center,
            });
        }
    }, [is3DMode, map, viewport.center]);
    if (style === MAP_STYLES.SATELLITE)
        return null;
    return (_jsx(Button, { onPress: handlePress, variant: "secondary-floating", iconOnly: true, icon: is3DMode ? TwoDimensionalIcon : ThreeDimensionalFilledIcon, children: is3DMode ? "2D" : "3D" }));
};
